import React from 'react';
import { get } from 'lodash';
import { useQueryClient } from 'react-query';
import { PauseTypography } from '../../../../components/PauseTypography';
import { PauseTextButton } from '../../../../components/PauseTextButton';
import { PauseTableTitle } from '../../../../components/PauseTable/components/PauseTableTitle';
import { PauseTableContainer } from '../../../../components/PauseTable';
import { PauseTooltip } from '../../../../components/PauseTooltip';

const taxIDsteps = [
  'Click on edit details on top-right. You will be taken to a new page',
  'On the new page, under Billing Information, click on "Update information"',
  'Under tax ID, select country under ID type',
  'And add or edit your tax ID',
  'Click on Save to save the information',
];

const TaxIDTooltip = () => (
  <div>
    <PauseTypography>
      Add your tax ID in a few clicks:
    </PauseTypography>
    <div css={(t) => ({
      marginTop: t.spacing(2),
    })}
    >
      <ol css={(t) => ({
        paddingLeft: t.spacing(2),
      })}
      >
        {taxIDsteps.map((step) => (
          <li key={step}>
            <PauseTypography>
              {step}
            </PauseTypography>
          </li>
        ))}
      </ol>
    </div>
  </div>
);

export const BillingSummary = (props: {
  onEditDetails: (any?) => any,
}) => {
  const queryClient = useQueryClient();
  const billingDetailsData = queryClient.getQueryData<any>('billingDetails');
  const billingDetailsList = [
    ['email', 'Email', billingDetailsData?.email || ''],
    ['card', 'Credit card', `XXXX XXXX XXXX ${billingDetailsData?.cardNumber} &bull; Valid till: ${billingDetailsData?.cardExpiry}`],
    ['taxID', 'Tax ID', billingDetailsData?.taxID],
  ];
  const {
    onEditDetails = () => null,
  } = props;
  return (
    <PauseTableContainer>
      <PauseTableTitle
        title="Billing details"
        actions={(
          // @ts-ignore
          <PauseTextButton
            onClick={onEditDetails}
          >
            Edit Details
          </PauseTextButton>
        )}
      />
      <div css={(t) => ({
        padding: t.spacing(2, 3, 3),
        borderTop: '2px solid',
        borderColor: get(t, 'palette.pause.background.medium'),
      })}
      >
        {billingDetailsList.map(([id, label, value]) => (
          <div
            key={id}
            css={(t) => ({
              marginBottom: t.spacing(2),
            })}
          >
            <PauseTypography
              variant="body2"
              color="pause.primary.medium"
            >
              {label}
              {id === 'taxID' && (
              <span css={() => ({
                '> div': {
                  display: 'inline-block',
                },
              })}
              >
                &nbsp;&bull;
                {' '}
                {/* @ts-ignore */}
                <PauseTooltip
                  enterDelay={100}
                  title={<TaxIDTooltip />}
                  aria-label="Profile"
                >
                  <span css={(t) => ({
                    color: get(t, 'palette.pause.primary.main'),
                    cursor: 'pointer',
                  })}
                  >
                    How to manage?
                  </span>
                </PauseTooltip>
              </span>
              )}
            </PauseTypography>
            <PauseTypography>
              <span dangerouslySetInnerHTML={{ __html: value || '-' }} />
            </PauseTypography>
          </div>
        ))}
      </div>
    </PauseTableContainer>
  );
};
